import Splide from '@splidejs/splide';
import { media } from '../tools/MQ';
export const init = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const addedElement = Array.from(mutation.addedNodes).find((node) => {
        return node.classList && node.classList.contains('action__tooltip');
      });
      const removedElement = Array.from(mutation.removedNodes).find((node) => {
        return node.classList && node.classList.contains('action__tooltip');
      });
      if (!addedElement && !removedElement) { 
        if (document.querySelector('.carousel_type-9')) {
          const carousel = document.querySelector('.carousel_type-9');
          const main = new Splide(carousel, {
            type       : 'fade',
            pagination : false,
            arrows     : false,
            drag: false
          });
  
          const infoElements = document.querySelectorAll('.info__wrapper');
          main.on('active',() => {
            setTimeout(() => {
              const activeSlide = document.querySelector('.splide__slide.is-active.is-visible[data-id]');
              infoElements.forEach((item) => {
                if (item.dataset.id === activeSlide.dataset.id) {
                  item.classList.add('active');
                }
                else {
                  item.classList.remove('active')
                }
              })
            },100)
          })
          
          const thumbnails = new Splide( '.carousel_type-9__thumbnails', {
            rewind          : true,
            isNavigation    : true,
            gap             : 16,
            fixedWidth: 180,
            fixedHeight: 135,
            pagination      : false,
            arrows: false,
            breakpoints : {
              640: {
                fixedWidth  : 86,
                fixedHeight : 58,
              },
            },
          });
  
          main.sync( thumbnails );
          main.mount();
          thumbnails.mount();
          if (main.length > 1) {
            //console.log(true)
            const { Controller } = main.Components;
            const arrowLeft = carousel.querySelector('.button--prev');
            const arrowRight = carousel.querySelector('.button--next');
  
            main.on('move', (newIndex) => {
                switch (newIndex) { 
                    case 0: 
                        arrowLeft.classList.add('u-js-hide'); 
                        arrowRight.classList.remove('u-js-hide');
                        break;
                    case Controller.getEnd():
                        arrowRight.classList.add('u-js-hide');  
                        arrowLeft.classList.remove('u-js-hide');
                        break;
                    default:
                        arrowLeft.classList.remove('u-js-hide');
                        arrowRight.classList.remove('u-js-hide');  
                } 
            });
            //console.log(arrowLeft)
            arrowLeft.addEventListener('click', () => Controller.go('<'));
            arrowRight.addEventListener('click', () => Controller.go('>'));
          } else {
            const arrowLeft = carousel.querySelector('.button--prev');
            const arrowRight = carousel.querySelector('.button--next');
            const thumbnailsWrapper = document.querySelector('.thumbnails-wrapper');
            const mediaContainer = carousel.querySelector('.b-media-container');
            arrowLeft.classList.add('u-js-hide');
            arrowRight.classList.add('u-js-hide');
            thumbnailsWrapper.classList.add('u-js-hide');
            mediaContainer.classList.add('single-item');

          }
        }
      }
    })
  })
  observer.observe(document.body, {
    childList: true,
    //subtree: true
  });
}